// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiple-colaboradores {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.multiple-colaboradores .btn-back {
  width: 100%;
}
.multiple-colaboradores .btn-back .item-circle {
  width: 40px;
  height: 40px;
  border-radius: 50rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid;
  color: #6e6e6e;
}
.multiple-colaboradores .btn-back .item-circle svg {
  margin: 0;
  fill: #6e6e6e;
}
.multiple-colaboradores .content-body {
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  padding: 0 150px;
  border: none;
  height: 70vh;
}
.multiple-colaboradores .content-body p {
  font-size: 16px;
  font-weight: bold;
  text-align: justify;
}
.multiple-colaboradores .content-body .btn-download {
  border: 2px solid #7a6be8;
  background: white;
  border-radius: 50rem;
  margin-top: 20px;
  color: #7a6be8;
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.multiple-colaboradores .content-body .btn-download:hover {
  border-color: #4b379c;
  color: #4b379c;
}
.multiple-colaboradores .content-body .btn-upload {
  background: linear-gradient(45deg, #7a6be8, #7a6be8);
  border-radius: 50rem;
  padding: 5px;
  color: white;
  width: 100%;
  margin: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 2px solid #7a6be8;
  transition: 0.3s ease;
}
.multiple-colaboradores .content-body .btn-upload:hover {
  filter: grayscale(20%);
  border-color: #4b379c;
}
.multiple-colaboradores .content-body .file-upgrade {
  margin: 15px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.multiple-colaboradores .content-body .file-upgrade .file-name {
  color: #0f5d7c;
}
.multiple-colaboradores .content-body .file-upgrade .bar-progress {
  position: relative;
  margin: 0 10px;
  border: 2px solid #0f5d7c;
  width: 300px;
  border-radius: 50rem;
  text-align: center;
  height: 20px;
  overflow: hidden;
}
.multiple-colaboradores .content-body .file-upgrade .bar-progress .progress {
  position: absolute;
  height: 100%;
  background: repeating-linear-gradient(45deg, #89d9f9, #89d9f9 10px, #40c8ff 10px, #40c8ff 20px);
}
.multiple-colaboradores .content-body .file-upgrade .bar-progress .upgrade-progress {
  color: #0f5d7c;
  position: absolute;
  font-size: small;
  font-weight: bold;
}
.multiple-colaboradores .content-body svg {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Views/Service/Views/PeopleAnalytics/Management/multipleColaboradores.sass"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AACJ;AACI;EACI,WAAA;AACR;AACQ;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;AACZ;AACY;EACI,SAAA;EACA,aAAA;AAChB;AACI;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AACR;AACQ;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;AACZ;AACQ;EACI,yBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACZ;AACY;EACI,qBAAA;EACA,cAAA;AAChB;AACQ;EACI,oDAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;AACZ;AACY;EACI,sBAAA;EACA,qBAAA;AAChB;AACQ;EACI,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACZ;AACY;EACI,cAAA;AAChB;AACY;EACI,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AAChB;AACgB;EACI,kBAAA;EACA,YAAA;EACA,+FAAA;AACpB;AACgB;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACpB;AACQ;EACI,kBAAA;AACZ","sourcesContent":[".multiple-colaboradores\n    display: flex\n    flex-direction: column\n    align-items: center\n\n    & .btn-back\n        width: 100%\n\n        & .item-circle\n            width: 40px\n            height: 40px\n            border-radius: 50rem\n            display: flex\n            align-items: center\n            justify-content: center\n            border: 3px solid\n            color: #6e6e6e\n\n            & svg\n                margin: 0\n                fill: #6e6e6e\n\n    & .content-body\n        display: flex\n        flex-direction: column\n        align-items: left\n        justify-content: left\n        padding: 0 150px\n        border: none\n        height: 70vh\n\n        & p\n            font-size: 16px\n            font-weight: bold\n            text-align: justify\n\n        & .btn-download\n            border: 2px solid #7a6be8\n            background: white\n            border-radius: 50rem\n            margin-top: 20px\n            color:#7a6be8\n            width: 100%\n            height: 44px\n            display: flex\n            justify-content: center\n            align-items: center\n\n            &:hover\n                border-color: #4b379c\n                color: #4b379c\n\n        & .btn-upload\n            background: linear-gradient(45deg, #7a6be8,#7a6be8 )\n            border-radius: 50rem\n            padding: 5px\n            color: white\n            width: 100%\n            margin: 10px 0\n            display: flex\n            justify-content: center\n            align-items: center\n            cursor: pointer\n            border: 2px solid #7a6be8\n            transition: .3s ease\n\n            &:hover\n                filter: grayscale(20%)\n                border-color: #4b379c\n\n        & .file-upgrade\n            margin: 15px 0\n            display: flex\n            justify-content: center\n            align-items: center\n\n            & .file-name\n                color: #0f5d7c\n\n            & .bar-progress\n                position: relative\n                margin: 0 10px\n                border: 2px solid #0f5d7c\n                width: 300px\n                border-radius: 50rem\n                text-align: center\n                height: 20px\n                overflow: hidden\n\n                & .progress\n                    position: absolute\n                    height: 100%\n                    background: repeating-linear-gradient(45deg,#89d9f9,#89d9f9 10px,#40c8ff 10px,#40c8ff 20px)\n\n                & .upgrade-progress\n                    color: #0f5d7c\n                    position: absolute\n                    font-size: small\n                    font-weight: bold\n\n        & svg\n            margin-right: 10px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
